var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1027.971 479.46"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.691 192.66h398.73a18.6 18.6 0 0118.01 23.25l-62.85 242.95a22.334 22.334 0 01-40.96 5.58l-93.17-161.14-225.6-74.38a18.6 18.6 0 015.84-36.26z",
    fill: "#d90101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.321 0a260.487 260.487 0 00-252.18 195.23l-25.36 98.09a148.858 148.858 0 00144.17 186.14l261.35-.14 363.78-.14a179.053 179.053 0 00-153.82-88.03h-216.58a74.375 74.375 0 01-72.02-93.04l25.12-97.16a148.872 148.872 0 01144.05-111.56h417.63a111.644 111.644 0 00108.04-83.68l1.47-5.67z",
    fill: "#fff"
  }))));
}
export default SvgLogoSmall;